"use client";
import { ReactNode } from "react";
import { Provider } from "react-redux";
import { store } from "lib/redux/store";
import { HighlightProvider } from "./HighlightContext";
import { MistakeAnalysisProvider, MistakeAnalysisData } from "./MistakeAnalysisContext";

/**
 * Wrapper component that provides Redux store, HighlightContext, and MistakeAnalysisContext to iframe children
 * This is necessary because iframe creates a new document context
 * 
 * Usage:
 * <ResumeIframeCSR>
 *   <ResumeIframeProviders mistakeData={mistakeData}>
 *     <ResumePDF enableHighlight={true} enableMistakeHighlight={true} ... />
 *   </ResumeIframeProviders>
 * </ResumeIframeCSR>
 */
export const ResumeIframeProviders = ({ 
  children, 
  mistakeData 
}: { 
  children: ReactNode;
  mistakeData?: MistakeAnalysisData | null;
}) => {
  return (
    <Provider store={store}>
      <HighlightProvider>
        <MistakeAnalysisProvider mistakeData={mistakeData ?? null}>
          {children}
        </MistakeAnalysisProvider>
      </HighlightProvider>
    </Provider>
  );
};
